// extracted by mini-css-extract-plugin
export default {"searchBox":"ProductsNav_searchBox__YhsFz","action":"ProductsNav_action__IBuOc"};